// extracted by mini-css-extract-plugin
module.exports = {"block":"block___1n4br","resourceName":"resourceName___3rkFV","btn":"btn___2-k8D"};